import { useContext } from "react";

import { JobListOrderByEnum } from "@nens/rana/api-v1";

import { useRanaSearchState } from "@/hooks/router/rana-search-state";
import { useRanaTableData } from "@/hooks/router/use-rana-table-data";
import { useContributorDropdown } from "@/hooks/use-contributor-dropdown";
import { useJobListQuery } from "@/queries/query-job";
import { ProjectContext } from "@/stores/project-provider";

import { useProcessDropdown } from "./use-process-dropdown";

export const useJobList = () => {
  const project = useContext(ProjectContext);
  const { page, offset, limit, setPage, orderingString, orderings, setPageSize, setOrdering } =
    useRanaTableData({
      keyAddon: "jobList",
      initialPageSize: 10,
      initialOrderings: { started_at: "za" },
    });
  const [selectedUserId, setSelectedUserId] = useRanaSearchState<string | null>("jbUser", null, [
    "string",
    "null",
  ]);
  const [selectedProcessId, setSelectedProcessId] = useRanaSearchState<string | null>(
    "jbProcess",
    null,
    ["string", "null"]
  );

  const contributorDropdown = useContributorDropdown({
    projects: [project],
    selectedUserId,
    setPage,
    setSelectedUserId,
  });

  const processDropdown = useProcessDropdown({
    selectedProcessId,
    setPage,
    setSelectedProcessId,
  });

  const { data: hasJobsData } = useJobListQuery({
    limit,
  });
  const hasJobs = !!hasJobsData?.total;

  const jobListQuery = useJobListQuery({
    offset,
    limit,
    orderBy: (orderingString || undefined) as JobListOrderByEnum,
    createdBy: selectedUserId ?? undefined,
    processId: selectedProcessId ?? undefined,
  });

  const { isLoading, data } = jobListQuery;
  const jobs = data?.items ?? [];

  const tableDataIds = jobs.map((item) => item.id).filter((id): id is string => !!id);
  const numPages = Math.ceil((data?.total ?? 0) / limit);

  return {
    hasJobs,
    processDropdown,
    contributorDropdown,
    page,
    limit,
    setPage,
    orderings,
    setPageSize,
    setOrdering,
    isLoading,
    jobs,
    tableDataIds,
    numPages,
  };
};
